import type { FC } from 'react';

import type { UserAvatarProps } from 'components/data-display/avatar/UserAvatar';
import { UserAvatar } from 'components/data-display/avatar/UserAvatar';
import { useSelectedProjectOwnershipUser } from 'state/ownership/ownershipMappingHooks';

interface OwnershipAvatarProps extends UserAvatarProps {
  userName: string | undefined | null;

  tooltip?: boolean | undefined;
}

function getInitial(str: string) {
  return str.charAt(0).match(/[a-z]/i)?.[0].toUpperCase() || '?';
}

export const OwnershipAvatar: FC<OwnershipAvatarProps> = ({ userName, tooltip = false, ...other }) => {
  const unknownUser = !userName;

  const user = useSelectedProjectOwnershipUser(userName || '');

  const knownUserHasAvatar = !unknownUser && user !== undefined && !!user.avatar;

  return (
    <>
      {unknownUser && <UserAvatar {...other} tooltip={tooltip && 'Unassigned'} value='' />}

      {knownUserHasAvatar && user !== undefined && (
        <UserAvatar {...other} tooltip={tooltip && `${user.firstName} ${user.lastName}`} value={user.avatar} />
      )}

      {!unknownUser && !knownUserHasAvatar && (
        <UserAvatar {...other} tooltip={tooltip && userName} value={getInitial(userName)} />
      )}
    </>
  );
};
